module.exports = __webpack_public_path__ + "static/media/Social.3a180f16.svg";